<template>
  <b-container fluid>
    <!-- Nav -->
    <b-row>
      <b-col>
        <div class="bg-be" />
        <b-nav class="ml-2" tabs align="left">
          <b-nav-item @click="onMenuClick('Home')">
            <span class="link"> <b-icon-archive /> Home </span>
          </b-nav-item>
          <b-nav-item
            @click="onMenuClick('Accounts')"
            id="ac"
            v-if="AuthType === 'sa'"
          >
            <span class="link"> <b-icon-building /> Accounts & Locations </span>
          </b-nav-item>
          <b-nav-item @click="onMenuClick('Items')" v-if="AuthType === 'sa'">
            <span class="link"> <b-icon-book /> Items </span>
          </b-nav-item>
          <b-nav-item
            @click="onMenuClick('Equipment')"
            v-if="AuthType === 'sa'"
          >
            <span class="link"> <b-icon-power /> Equipment </span>
          </b-nav-item>
          <b-nav-item
            @click="onMenuClick('Users')"
            v-if="AuthType === 'sa' || AuthType === 'ca'"
          >
            <span class="link"> <b-icon-people /> Users </span>
          </b-nav-item>
          <b-nav-item @click="onMenuClick('SaUsers')" v-if="AuthType === 'sa'">
            <span class="link"> <b-icon-people /> Internal Users </span>
          </b-nav-item>
        </b-nav>
      </b-col>
    </b-row>

    <!-- Body -->
    <b-row>
      <b-col>
        <b-container class="mb-5 mt-5" fluid>
          <b-row>
            <b-col>
              <router-view />
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      openState: true,
      dir: {
        Users: "/admin/user",
        SaUsers: "/admin/sa",
        Home: "/admin/",
        Items: "/admin/items",
        Equipment: "/admin/equipment",
        Accounts: "/admin/accounts"
      }
    };
  },
  computed: {
    AuthType() {
      return this.$store.getters["user/authType"];
    }
  },
  methods: {
    onMenuClick(e) {
      debugger;
      this.$store.dispatch("accounts/currentAccount").then(() => {
        debugger;
        var to = this.dir[e];

        return this.$router.push(to);
      });
    }
  }
};
</script>

<style scoped>
.bg-be {
  position: absolute;
  background-color: #526877 !important;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.link {
  color: #fff !important;
  font-weight: bold;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/dashboard.vue